/**
 * ErrorListItemRange  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { IDocumentRange } from "@adapptio/lib-blueprint";

export interface IErrorListItemRangeProps {
	range: IDocumentRange;
}

export const ErrorListItemRange = React.memo<IErrorListItemRangeProps>(({ range }) => {
	const baseClass = BEM("edt-error-list", "item-range");

	return (
		<div className={baseClass.toClassName()}>
			[{range.start.line + 1}, {range.start.col + 1}]
		</div>
	);
});

ErrorListItemRange.displayName = "ErrorListItemRange";
